import React from 'react';
import { DetailedRadio } from '@amzn/atoz-web/DetailedRadio';
import { RadioCardMessage } from './RadioCardMessage';
import { isPremiumPayBreakDownAvailable } from '../utils';
import { DateTime } from 'luxon';
import { Col, View } from '@amzn/atoz-web';
import { PremiumPayMessage } from './PremiumPayMessage';
import { getDateTimeIntervalStringFromShift } from '@amzn/atoz-shiftapp-utilities';
export var DropShiftRadioCard = function (_a) {
    var dropOpportunity = _a.dropOpportunity, scheduleShift = _a.scheduleShift, setSelectedDropOpportunity = _a.setSelectedDropOpportunity, checked = _a.checked;
    var startTime = DateTime.fromISO(dropOpportunity.shift.timeRange.start);
    var endTime = DateTime.fromISO(dropOpportunity.shift.timeRange.end);
    var hasPayBreakdownPremiums = isPremiumPayBreakDownAvailable(dropOpportunity);
    var hasPremiums = hasPayBreakdownPremiums || !!(dropOpportunity === null || dropOpportunity === void 0 ? void 0 : dropOpportunity.incentivePay);
    function handleClick() {
        setSelectedDropOpportunity(dropOpportunity);
    }
    return (React.createElement(DetailedRadio, { name: "DropShiftDetailRadioCard", titleText: getDateTimeIntervalStringFromShift(startTime, endTime), details: React.createElement(Col, null,
            React.createElement(View, { dataTestId: "drop-merged-shift-radio-card-message" },
                React.createElement(RadioCardMessage, { dropOpportunity: dropOpportunity, scheduleShift: scheduleShift })),
            hasPremiums && (React.createElement(View, { dataTestId: "drop-merged-shift-premium-pay-message" },
                React.createElement(PremiumPayMessage, { fromPayBreakdown: hasPayBreakdownPremiums, dropOpportunity: dropOpportunity })))), dataTestId: "DropShiftRadioCard", onClick: handleClick, defaultChecked: checked }));
};
